const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

import async from 'async';


function isEmail(email) {
    return EMAIL_PATTERN.test(String(email).toLowerCase());
}

class Validation {
    constructor(...selectors) {
        this.status = {};
        this.inputs = selectors.reduce((ret, item) => {
            if (Array.isArray(item)) {
                return ret.concat(item);
            }
            ret.push(item);
            return ret;
        }, []);
    }

    withRules(rules) {
        this.rules = rules;
        return this;
    }

    validate($elem) {

    }

    watch(options = {}, interval = 200) {
        setInterval(() => {
            async.parallel(this.inputs.filter(s => $(s).length > 0).map(s => done => {
                const $s = $(s);
                const ok = this.validate($s);
                if (ok) {
                    //if (options.valid($s, done);
                } else {

                }
            }), (err) => {

            });
        }, interval);
    }
}

export default Validation;
